import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import fondo from '../assets/zalud.webp';
import Swal from 'sweetalert2';
import '../styles/disenocalculadorasbase.css';

export default function CalculadoraFondoSalud() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }

    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="calculadora-back"
      >
        ← Regresar al Menú
      </button>
      <div className="calculadora-container">
        <div 
          className="calculadora-left"
          style={{ backgroundImage: `url(${fondo})` }}
        >
          <div className="calculadora-overlay">
            <h1>Invierte en tu salud</h1>
            <p>
              Un fondo de salud te da tranquilidad ante cualquier imprevisto. Calcula tu aporte mensual y comienza a proteger tu bienestar desde hoy.
            </p>
          </div>
        </div>

        <div className="calculadora-form">
          <h2>Calculadora Fondo de Salud</h2>

          <label>Nombre:</label>
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />

          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={(e) => setEdad(e.target.value)}
          />

          <label>Ingreso al fondo (mensualmente):</label>
          <input
            type="number"
            value={ingreso}
            onChange={(e) => setIngreso(e.target.value)}
          />

          <label>Tiempo (en años):</label>
          <select value={tiempo} onChange={(e) => setTiempo(e.target.value)}>
            <option value="">Selecciona un tiempo</option>
            {[...Array(20)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>

          <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="calculadora-link"
          >
            La salud no es un juego. ¡Agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}







